import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";
import LoadSerializer from "../serializers/LoadSerializer";
import LaneHistorySerializer from "../serializers/LaneHistorySerializer";
import LoadBoardSerializer from "../serializers/LoadBoardSerializer";
import OfferCommentSerializer from "../serializers/OfferCommentSerializer";
import CallinTrackingSerializer from "../serializers/CallinTrackingSerializer";

export default class LoadRepository {
  LOADS_BASE = "/api/loads";
  ORDER_BASE = "/api/order";
  ORDERS_BASE = "/api/orders";
  CARRIERS_BASE = "/api/carriers";
  DAT_BASE = "/api/dat";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async getLoad(instance, params) {
    const token = await getToken(instance);
    const path = `${this.LOADS_BASE}/orders?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(LoadSerializer.deSerialize(req.load));
  }

  async updateLoadStatus(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.ORDER_BASE}/updateStatus`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ order: LoadSerializer.serialize(payload) })
    });

    return Promise.resolve(LoadSerializer.deSerialize(req.order));
  }

  async getLaneHistory(instance, params) {
    const token = await getToken(instance);
    const path = `${this.ORDERS_BASE}/history?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    if (req.laneHistory) {
      return Promise.resolve({
        loads: req.laneHistory.map(load => (
          LaneHistorySerializer.deSerialize(load)
        )),
        maxRows: req.maxRows,
        laneHistoryHeader: req.laneHistoryHeader
      });
    } else {
      return Promise.resolve({});
    }
  }

  async getLoadHistory(instance, params) {
    const token = await getToken(instance);
    const path = `${this.ORDERS_BASE}/loadhistory?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    if (req.loadHistory) {
      return Promise.resolve({
        loads: req.loadHistory.map(load => (
          LaneHistorySerializer.deSerialize(load)
        )),
        maxRows: req.maxRows,
        loadHistoryHeader: req.loadHistoryHeader
      });
    } else {
      return Promise.resolve({});
    }
  }

  async getLoads(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/availableLoadsBoard?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.loads) {
      return Promise.resolve(
        req.loads.map(load => (
          LoadBoardSerializer.deSerialize(load)
        ))
      );
    } else {
      return Promise.resolve({});
    }
  }

  async getLoadComments(instance, params) {
    const token = await getToken(instance);
    const path = `${this.ORDER_BASE}/comments?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.comments) {
      return Promise.resolve(req.comments.map(comment => (
        OfferCommentSerializer.deSerialize(comment)
      )));
    } else {
      return Promise.resolve([]);
    }
  }

  async getLoadCallins(instance, loadId) {
    const token = await getToken(instance);
    const path = `${this.LOADS_BASE}/callintracking?orderId=${loadId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.callins) {
      return Promise.resolve(req.callins.map(callin => (
        CallinTrackingSerializer.deSerialize(callin)
      )));
    } else {
      return Promise.resolve([]);
    }
  }

  async findLoadsById(instance, loadId) {
    const token = await getToken(instance);
    const path = `${this.ORDER_BASE}/searchbyid?id=${loadId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.orders) {
      return Promise.resolve(req.orders.map(order => (
        LoadSerializer.deSerialize(order)
      )));
    } else {
      return Promise.resolve([]);
    }
  }

  async postLoad(instance, load) {
    const token = await getToken(instance);
    const path = `${this.DAT_BASE}/load`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ load: LoadBoardSerializer.serialize(load) })
    });

    return Promise.resolve(req);
  }

  async unpostLoad(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.DAT_BASE}/load`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "DELETE",
      headers: this.headers,
      body: JSON.stringify({ load: LoadBoardSerializer.serialize(payload) })      
    });

    return Promise.resolve(req);
  }
}